import { MessagingChannel } from 'jschannel';
import { StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

export async function sendAttemptedStatement(
    channel: MessagingChannel,
    contentId: string,
    duration: number,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/attempted`,
                display: {
                    und: 'attempted'
                }
            },
            object: {
                id: contentId
            },
            result: {
                duration: Math.max(0, duration)
            }
        }
    ]);
}
